import { render, staticRenderFns } from "./PrincipalImg.vue?vue&type=template&id=c5059880&scoped=true"
import script from "./PrincipalImg.vue?vue&type=script&lang=js"
export * from "./PrincipalImg.vue?vue&type=script&lang=js"
import style0 from "./PrincipalImg.vue?vue&type=style&index=0&id=c5059880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5059880",
  null
  
)

export default component.exports